<template>
  <div class="result">
    <v-row no-gutters class="justify-center">
      <v-col cols="6" md="3" class="board">
        <v-card elevation="2">
          <v-card-text>
            <div>累計投擲次數</div>
            <p class="display-1 text--primary">{{ animated_total_throw }}</p>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6" md="3" class="board">
        <v-card elevation="2">
          <v-card-text>
            <div>累計相交次數</div>
            <p class="display-1 text--primary">{{ animated_total_cross }}</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row no-gutters class="justify-center">
      <v-col cols="12" class="board">
        <v-card elevation="0">
          <v-card-text>
            <!-- <div>pi~2x累計投擲次數/累計投擲次數</div> -->
            <p class="display-1 text--primary" ><katex-element expression="\\\pi\approx"/> {{ est_pi }}</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<style  scoped>
.board {
  padding-left: 10px!important;
  padding-right: 10px!important;
  padding-top:10px!important;
}
</style>
<script>
  import {db} from '../plugins/firebase'; 
  import { gsap } from "gsap";

  export default {
    name: "Result",
    data: () => ({
      total_throw:0,
      total_cross:0,
      temp_total_throw: 0,
      temp_total_cross: 0
    }),
    computed: {
    // a computed getter
      est_pi: function () {
        if(this.total_cross == 0){
          return '？'
        }else{
          return Math.round(2*this.total_throw.toFixed(0)/this.total_cross.toFixed(0)*10000000)/10000000
        }
      },
      animated_total_throw:function(){
        return this.total_throw.toFixed(0);
      },
      animated_total_cross:function(){
        return this.total_cross.toFixed(0);
      }
    },
    created() {
      if ( window.location !== window.parent.location ) 
      { 
          console.log("iframe loaded"); 
      }  
      else { 
          this.$router.push('/') 
      } 
      db.collection('data').doc('form').collection('report').onSnapshot((snapshot) => {
            this.temp_total_throw = 0;
            this.temp_total_cross = 0;
            snapshot.forEach((doc) => {
                this.temp_total_throw += doc.data().throw;
                this.temp_total_cross += doc.data().cross;
            });
            gsap.to(this.$data, { duration: 0.5, total_throw: this.temp_total_throw ,total_cross:this.temp_total_cross});
           
      })
    },
  }
</script>